import { render, staticRenderFns } from "./ViewNote.vue?vue&type=template&id=6b9da855&scoped=true"
import script from "./ViewNote.vue?vue&type=script&lang=js"
export * from "./ViewNote.vue?vue&type=script&lang=js"
import style0 from "./ViewNote.vue?vue&type=style&index=0&id=6b9da855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9da855",
  null
  
)

export default component.exports